import { color } from '@stockbit/ui';
import { Entries } from 'react';
import { ITabList, TabListNameEnums } from '../../../@types/company.d';
import { ChartTimeFrames, FRChartTimeFrames } from './constants.types';

export type CorpActionCategoryKeys =
  | 'dividend'
  | 'stocksplit'
  | 'reversesplit'
  | 'rightissue'
  | 'warrant'
  | 'bonus'
  | 'tenderoffer'
  | 'pubex'
  | 'rups';

const CORP_ACTIONS: Record<CorpActionCategoryKeys, string> = {
  dividend: 'Dividend',
  stocksplit: 'Stock Split',
  reversesplit: 'Reverse Split',
  rightissue: 'Right Issue',
  warrant: 'Warrant',
  bonus: 'Bonus',
  tenderoffer: 'Tender Offer',
  pubex: 'Pubex',
  rups: 'RUPS',
};

const CORP_ACTION_NAVS = [
  { value: 'all', label: 'All' },
  ...(Object.entries(CORP_ACTIONS) as Entries<typeof CORP_ACTIONS>).map(
    ([value, label]) => ({
      value,
      label,
    }),
  ),
];

const chartTimeframes: { value: ChartTimeFrames; label: string }[] = [
  { value: 'today', label: '1D' },
  { value: '1w', label: '1W' },
  { value: '1m', label: '1M' },
  { value: '3m', label: '3M' },
  { value: 'ytd', label: 'YTD' },
  { value: '1y', label: '1Y' },
  { value: '3y', label: '3Y' },
  { value: '5y', label: '5Y' },
];

const priceChange = {
  netral: {
    icon: '',
    color: color.nobel,
  },
  up: {
    icon: 'icon-symbol_up',
    color: color.primary,
  },
  down: {
    icon: 'icon-symbol_down',
    color: color.sunsetOrange,
  },
};

const SENTIMENT_INDICATOR_COLORS = [
  {
    background: color.royalBlue,
    label: 'Pessimistic',
  },
  {
    background: color.steelBlue,
    label: 'Cautious',
  },
  {
    background: color.scooter,
    label: 'Neutral',
  },
  {
    background: color.java,
    label: 'Optimstic',
  },
  {
    background: color.jade,
    label: 'Positive',
  },
];

const CHART_COLOR = [
  '#3366FF',
  '#ff00ff',
  '#ff7900',
  '#008700',
  '#ff0000',
  '#1c1cb5',
  '#00ff00',
  '#7f33ba',
  '#e83535',
  '#800000',
  '#666666',
  '#000000',
];

const TAB_LIST_NAME = TabListNameEnums;
const TAB_LIST: ITabList = {
  [TAB_LIST_NAME.STREAM]: {
    label: 'Stream',
    path: '',
    isNewFeature: false,
  },
  [TAB_LIST_NAME.NEWS]: { label: 'News', path: '/news', isNewFeature: false },
  [TAB_LIST_NAME.KEYSTATS]: {
    label: 'Key Stats',
    path: '/keystats',
    isNewFeature: false,
  },
  [TAB_LIST_NAME.ANALYST]: {
    label: 'Analysis',
    path: '/analyst',
    isNewFeature: true,
  },
  [TAB_LIST_NAME.FINANCIALS]: {
    label: 'Financials',
    path: '/financials',
    isNewFeature: false,
  },
  [TAB_LIST_NAME.FUNDACHART]: {
    label: 'Fundachart',
    path: '/fundachart',
    isNewFeature: false,
  },
  [TAB_LIST_NAME.SEASONALITY]: {
    label: 'Seasonality',
    path: '/seasonality',
    isNewFeature: false,
  },
  [TAB_LIST_NAME.CHARTBIT]: {
    label: 'Chartbit',
    path: '/chartbit',
    isNewFeature: false,
  },
  [TAB_LIST_NAME.COMPARISON]: {
    label: 'Comparison',
    path: '/comparison',
    isNewFeature: false,
  },
  [TAB_LIST_NAME.INSIDER]: {
    label: 'Insider',
    path: '/insider',
    isNewFeature: true,
  },
  [TAB_LIST_NAME.PROFILE]: {
    label: 'Profile',
    path: '/profile',
    isNewFeature: false,
  },
  [TAB_LIST_NAME.CORP_ACTION]: {
    label: 'Corp. Action',
    path: '/corpaction',
    isNewFeature: false,
  },
  [TAB_LIST_NAME.CONSENSUS]: {
    label: 'EPS Estimate',
    path: '/consensus',
    isNewFeature: false,
  },
};

const TAB_ANALYST_NEW_NAME = 'analysis';
const TAB_CORP_ACTION_NEW_NAME = 'corpaction';
const CLEVERTAP_ANALYST = 'Analyst Ratings - Tab Menu Selected';
const CLEVERTAP_SEASONALITY = 'Seasonality - Tab Menu Selected';
const SOURCE_MENU = 'Menu';

const FR_CHART_TYPES = [
  { value: 'yield', label: 'Yield' },
  { value: 'buy_price_rate', label: 'Harga Beli' },
  { value: 'sell_price_rate', label: 'Harga Jual' },
];

const chartTimeframesFR: { value: FRChartTimeFrames; label: string }[] = [
  { value: '1d', label: '1D' },
  { value: '1m', label: '1M' },
  { value: '3m', label: '3M' },
  { value: 'ytd', label: 'YTD' },
  { value: '1y', label: '1Y' },
  { value: '3y', label: '3Y' },
  { value: '5y', label: '5Y' },
  { value: 'all', label: 'All' },
];

export {
  CORP_ACTIONS,
  CORP_ACTION_NAVS,
  priceChange,
  chartTimeframes,
  SENTIMENT_INDICATOR_COLORS,
  CHART_COLOR,
  TAB_LIST,
  TAB_LIST_NAME,
  TAB_ANALYST_NEW_NAME,
  TAB_CORP_ACTION_NEW_NAME,
  CLEVERTAP_ANALYST,
  CLEVERTAP_SEASONALITY,
  SOURCE_MENU,
  FR_CHART_TYPES,
  chartTimeframesFR,
};
